import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms of Service</h1>
            <p className="text-lg text-gray-600">Last updated: December 2024</p>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Agreement to Terms</h2>
              <p className="text-gray-700 mb-6">
                By accessing and using Cofunnels services, you accept and agree to be bound by the terms and provision 
                of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Services Description</h2>
              <p className="text-gray-700 mb-4">
                Cofunnels provides done-for-you sales funnel development services, including:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                <li>ClickFunnels and GoHighLevel funnel development</li>
                <li>Lead generation funnel creation</li>
                <li>E-commerce funnel optimization</li>
                <li>Webinar funnel setup</li>
                <li>Conversion rate optimization</li>
                <li>Custom funnel consulting</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Payment Terms</h2>
              <div className="bg-blue-50 p-6 rounded-lg mb-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Payment Schedule</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>50% deposit required to begin work</li>
                  <li>Remaining 50% due upon project completion</li>
                  <li>Monthly retainer services billed in advance</li>
                  <li>All payments processed securely via Stripe</li>
                </ul>
              </div>
              <p className="text-gray-700 mb-6">
                Refunds are available within 7 days of project start date if no work has been delivered. 
                After work begins, refunds are prorated based on work completed.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Project Delivery</h2>
              <p className="text-gray-700 mb-4">Timeline commitments:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                <li><strong>Simple Funnels:</strong> 3-5 business days</li>
                <li><strong>Complex Funnels:</strong> 7-14 business days</li>
                <li><strong>Enterprise Projects:</strong> 2-4 weeks</li>
                <li><strong>Rush Orders:</strong> 24-48 hours (additional fees apply)</li>
              </ul>
              <p className="text-gray-700 mb-6">
                Delivery times begin after receipt of all required materials and 50% deposit. 
                Delays caused by client feedback or material provision extend delivery times accordingly.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Client Responsibilities</h2>
              <p className="text-gray-700 mb-4">Clients agree to:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                <li>Provide all necessary content, images, and copy within 48 hours</li>
                <li>Grant necessary access to third-party platforms (ClickFunnels, etc.)</li>
                <li>Respond to revision requests within 72 hours</li>
                <li>Provide clear, detailed project requirements</li>
                <li>Make timely payments as agreed</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Intellectual Property</h2>
              <p className="text-gray-700 mb-6">
                Upon full payment, clients receive full ownership of custom-developed funnels. However, 
                Cofunnels retains rights to proprietary methodologies, templates, and processes used in development. 
                We reserve the right to showcase completed work in our portfolio with client consent.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Limitation of Liability</h2>
              <p className="text-gray-700 mb-6">
                Cofunnels' liability is limited to the amount paid for services. We are not responsible for 
                lost profits, revenue, or business opportunities. While we strive for optimal performance, 
                we cannot guarantee specific conversion rates or business results.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Termination</h2>
              <p className="text-gray-700 mb-6">
                Either party may terminate services with 30 days written notice. Upon termination, 
                clients receive all completed work and pay for services rendered. Ongoing projects 
                will be completed unless otherwise agreed.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact Information</h2>
              <p className="text-gray-700 mb-4">
                For questions about these terms, contact us:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>Email:</strong> legal@cofunnels.com</p>
                <p className="text-gray-700 mb-2"><strong>Business Email:</strong> hello@cofunnels.com</p>
                <p className="text-gray-700"><strong>Response Time:</strong> Within 24 hours</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}